<template>
    <div>
        <div v-show="passed_filter_left" class="designeroption">
            <h3>Left Side Options</h3>
            <synseal-designer-question-select-frame-sidepanel class="sidepanel-option" :fabricator="fabricator"
                                                              :door-range="doorRange"
                                                              v-model:target="target.left"
                                                              :frame-material="frameMaterial"
                                                              :frame-style-id="frame_id"
                                                              :frame-colour-external="frameColourExternal"
                                                              :frame-colour-internal="frameColourInternal"
                                                              :title="'Select Left Side Panel Style'"
                                                              :measurement.sync="measurements.left_width"
                                                              measurement-key="left_width"
                                                              measurement-label="Enter your Left Side Panel Width"
                                                              :component_id="'left_side_panel_style'"
            ></synseal-designer-question-select-frame-sidepanel>

            <div v-if="passed_filter_left_comp">
                <synseal-designer-question-select-comp-options class="sidepanel-option" :fabricator="fabricator"
                                                               v-model:target="target.left_composite_id"
                                                               :door-range="doorRange"
                                                               :title="'Select Left Side Panel Composite Style'"
                                                               :component_id="'left_side_panel_composite_style'"
                ></synseal-designer-question-select-comp-options>

                <div v-if="passed_filter_left_comp_glass">
                    <synseal-designer-question-select-comp-glass :fabricator="fabricator"
                                                                 v-model:target="target.left_composite_glass_id"
                                                                 :comp-slab="target.left_composite_id"
                                                                 :laminated-glass="laminatedGlass"
                                                                 :title="'Select Left Side Panel Composite Glass'"
                                                                 :component_id="'left_side_panel_composite_glass'"
                    ></synseal-designer-question-select-comp-glass>

                    <synseal-designer-question-glass-backing-design title="Left Side Backing Glass"
                                                                    :fabricator="fabricator"
                                                                    v-model:target="target.left_composite_backing_glass_id"
                                                                    :slab="target.left_composite_id"
                                                                    :glass-design="target.left_composite_glass_id"
                                                                    :component_id="'left_side_panel_composite_backing_glass'"
                    ></synseal-designer-question-glass-backing-design>
                </div>
            </div>
            <div v-show="passed_filter_left_glass">
                <synseal-designer-question-select-side-glass :fabricator="fabricator"
                                                     v-model:target="target.left_panel_glass_id"
                                                             :frame-combination="frameStyle.frame_id"
                                                             :secured-by-design="securedByDesign"
                                                             :side-variant="target.left"
                                                     :title="'Select Left Side Panel Glass'"
                                                             :component_id="'left_side_panel_glass'"
                ></synseal-designer-question-select-side-glass>

                <synseal-designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                                     v-model:target="target.left_panel_backing_glass_id"
                                                                     :panel-glass-id="target.left_panel_glass_id"
                                                                     :title="'Select Left Side Panel Backing Glass'"
                                                                     :component_id="'left_side_panel_backing_glass'"
                ></synseal-designer-question-select-side-glass-obscure>
            </div>
        </div>

        <div v-show="passed_filter_right" class="designeroption">
            <h3>Right Side Options</h3>
            <synseal-designer-question-select-frame-sidepanel class="sidepanel-option" :fabricator="fabricator"
                                                              :door-range="doorRange"
                                                              v-model:target="target.right"
                                                              :frame-material="frameMaterial"
                                                              :frame-style-id="frame_id"
                                                              :frame-colour-external="frameColourExternal"
                                                              :frame-colour-internal="frameColourInternal"
                                                              :title="'Select Right Side Panel Style'"
                                                              :measurement.sync="measurements.right_width"
                                                              measurement-key="right_width"
                                                              measurement-label="Enter your Right Side Panel Width"
                                                              :component_id="'right_side_panel_style'"
            ></synseal-designer-question-select-frame-sidepanel>

            <div v-if="passed_filter_right_comp">
                <synseal-designer-question-select-comp-options class="sidepanel-option" :fabricator="fabricator"
                                                       v-model:target="target.right_composite_id"
                                                               :door-range="doorRange"
                                                       :title="'Select Right Side Panel Composite Style'"
                                                               :component_id="'right_side_panel_composite_style'"
                ></synseal-designer-question-select-comp-options>

                <div v-if="passed_filter_right_comp_glass">
                    <synseal-designer-question-select-comp-glass :fabricator="fabricator"
                                                         v-model:target="target.right_composite_glass_id"
                                                         :comp-slab="target.right_composite_id"
                                                                 :laminated-glass="laminatedGlass"
                                                         :title="'Select Right Side Panel Composite Glass'"
                                                                 :component_id="'right_side_panel_composite_glass'"
                    >
                    </synseal-designer-question-select-comp-glass>

                    <synseal-designer-question-glass-backing-design title="Right Side Backing Glass"
                                                            :fabricator="fabricator"
                                                            v-model:target="target.right_composite_backing_glass_id"
                                                            :slab="target.right_composite_id"
                                                            :glass-design="target.right_composite_glass_id"
                                                            :component_id="'right_side_panel_composite_backing_glass'"
                    ></synseal-designer-question-glass-backing-design>
                </div>
            </div>
            <div v-show="passed_filter_right_glass">
                <synseal-designer-question-select-side-glass :fabricator="fabricator"
                                                     v-model:target="target.right_panel_glass_id"
                                                             :frame-combination="frameStyle.frame_id"
                                                             :secured-by-design="securedByDesign"
                                                             :side-variant="target.right"
                                                             :title="'Select Right Side Panel Glass'"
                                                             :component_id="'right_side_panel_glass'"
                ></synseal-designer-question-select-side-glass>

                <synseal-designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.right_panel_backing_glass_id"
                                                             :panel-glass-id="target.right_panel_glass_id"
                                                             :title="'Select Right Side Panel Backing Glass'"
                                                             :component_id="'right_side_panel_backing_glass'"
                ></synseal-designer-question-select-side-glass-obscure>
            </div>
        </div>

        <div v-show="passed_filter_top_glass" class="designeroption">
            <h3>Top Light Options</h3>
            <synseal-designer-question-select-side-glass :fabricator="fabricator"
                                                         v-model:target="target.top_panel_glass_id"
                                                         :frame-combination="frameStyle.frame_id"
                                                         :secured-by-design="securedByDesign"
                                                         :side-variant="0"
                                                         :title="'Select Top Panel Glass'"
                                                         :component_id="'top_panel_glass'"
            ></synseal-designer-question-select-side-glass>

            <synseal-designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                         v-model:target="target.top_panel_backing_glass_id"
                                                         :panel-glass-id="target.top_panel_glass_id"
                                                         :title="'Select Top Panel Backing Glass'"
                                                         :component_id="'top_panel_backing_glass'"
            ></synseal-designer-question-select-side-glass-obscure>
        </div>
    </div>
</template>


<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameSidePanels from "../DesignerQuestionSelectFrameSidePanels.vue";
    import TileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameSidePanels,
            TileQuestion,
        ],
        props:{
            title: {
                default(){
                    return 'Select Side Panel Style';
                }
            },
            component_id: {
                default(){
                    return 'side_panel_style';
                }
            },
            frameMaterial: {
                required: true,
            },
            laminatedGlass: {
                required: true,
            },
        },
    }
</script>
